import React from 'react';
import {Box, Grid} from '@mui/material';
import ImageGallery from 'react-image-gallery';
import {Image} from "@/types";
import {useResizeHook} from "@/lib";




const ServiceCategoryRowGallery = ({images}: { images: Image[] }) => {

    const disableSwipe = true
    const {lessThanMuiMd} = useResizeHook();

    return (<Grid
            size={{lg: 8, md: 12, xs: 12}}
        >
            <Box
                sx={{
                    '.image-gallery-slide-wrapper': {
                        pointerEvents: disableSwipe ? 'none' : 'inherit',
                    }
                }}
            >
                {!!images?.length && (
                    <ImageGallery
                        items={lessThanMuiMd ? [images[0]] : images}
                        showThumbnails={false}
                        showBullets={false}
                        showNav={false}
                        showPlayButton={false}
                        fullScreenButton={false}
                        showFullscreenButton={false}
                        disableSwipe={disableSwipe}
                    />
                )}
            </Box>
        </Grid>
    );
};

export default ServiceCategoryRowGallery;
